<template>
  <view class="avatar-frame-container" :style="{ width: width + 'px', height: height + 'px' }">
    <image :src="avatarFrameUrl" mode="aspectFill" class="avatar-frame-img" />
    <image :src="avatarUrl" mode="aspectFill" class="avatar-img"/>
  </view>
</template>
<script setup lang="ts">
import { watch, ref, onMounted } from 'vue'
import { getCurrentUserInfoAvatar } from '@/api/index'
const props = defineProps({
  width: {
    type: Number,
    default: 100,
  },
  height: {
    type: Number,
    default: 100,
  },
  avatarUrl: {
    type: String,
    default: '',
  },
  userKey: {
    type: String,
    default: '',
  },
  avatarFrameUrl: {
    type: String,
    default: '',
  },
})

const avatarFrameUrl = ref('')
const avatarUrl = ref('')

const getAvatarFrameUrl = (userKey: string) => {
  if (userKey) {
    getCurrentUserInfoAvatar({ userKey }).then((res: any) => {
      avatarUrl.value = res.data.avatar
      avatarFrameUrl.value = res.data.avatarFrameUrl
    })
  }
}

// Watch for changes in userKey
watch(() => props.userKey, (newVal) => {
  if (newVal) {
    getAvatarFrameUrl(newVal)
  }
}, { immediate: true })


watch(() => props.avatarUrl, (newVal) => {
  if (newVal) {
    avatarUrl.value = newVal
  }
}, { immediate: true })

watch(() => props.avatarFrameUrl, (newVal) => {
  if (newVal) {
    avatarFrameUrl.value = newVal
  }
}, { immediate: true })

// // Watch for changes in avatarUrl prop
// watch(() => props.avatarUrl, (newVal) => {
//   if (newVal) {
//     avatarUrl.value = newVal
//   }
// }, { immediate: true })

onMounted(() => {
  if(props.avatarUrl){
    avatarUrl.value = props.avatarUrl
  }
  if (props.avatarFrameUrl) {
    avatarFrameUrl.value = props.avatarFrameUrl
    // avatarUrl.value = props.avatarUrl
  }else{
    if (props.userKey) {
    getAvatarFrameUrl(props.userKey)
  }
  }

  console.log('avatarFrameUrl', avatarFrameUrl.value)
  console.log('avatarUrl', avatarUrl.value)

})
</script>

<style scoped>
.avatar-frame-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.avatar-frame-img {
  position: absolute;
  top: -33%;
  left: -33%;
  width: 166%;
  height: 166%;
  z-index: 2;
  pointer-events: none;
  /* opacity: 0.2; */
}
.avatar-img {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  z-index: 1;
  border: 1px solid #fff;
}
</style>